<template>
  <v-container fluid>
    <v-layout
      row
      wrap>
      <h1>Testing Tool</h1>
      <v-spacer />

      <input type="file" @change="getExcelData" class="hidden" ref="uploadFile">
      <a href="/files/sample.xlsx" download>
        <v-btn color="primary" outline>
          Download Sample
        </v-btn>
      </a>
      <v-btn color="primary" @click="$refs.uploadFile.click()">Upload Intents File</v-btn>
      <JsonExcel :data="tableData">
        <v-btn :disabled="!tableData.length" color="primary">
          download data
        </v-btn>
      </JsonExcel>
    </v-layout>
    <div class="card-curvey">
      <v-layout>
        <v-flex sm3 class="ml-0 pl-0">
          <v-text-field  v-model="matchingRegex" outline placeholder="matching regex"/>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="tableData"
        :hide-default-header="true"
        :hide-default-footer="true"
        class="elevation-1 nlp-data-table"
        :pagination.sync="pagination"
      >
        <template v-slot:items="props">
          <td>{{ props.item.index }}</td>
          <td>{{ props.item.Intent }}</td>
          <td class="">{{ props.item.Lang }}</td>
          <td class="">{{ props.item.Question }}</td>
          <td class="">{{ props.item.Answer }}</td>
          <td class="">{{ props.item['Chatbot Answer'] }}</td>
          <td class="">{{ props.item.PASSED}}</td>
          <td class="">{{ props.item['App ID']}}</td>
          <td class="">{{ props.item['Predicted Intent']}}</td>
          <td class="">{{ props.item['Score']}}</td>
          <td class="text-xs-right">{{ props.item['Entites']}}</td>
        </template>
      </v-data-table>
    </div>


  </v-container>
</template>

<script>
  import JsonExcel from "vue-json-excel";
  import XLSX from 'xlsx'
  export default {
    name: "intentReportTool",
    components: {
      JsonExcel
    },
    data() {
      return {
        matchingRegex: '',
        sheetData: [],
        dataFetched: false,
        pagination: {
          rowsPerPage: 100000
        },
        messages: [],
        tableData: [],
        headers: [
          {
            text: 'Index',
            align: 'left',
            value: 'index'
          },
          {
            text: 'Intent',
            align: 'left',
            value: 'Intent'
          },
          { text: 'Lang', value: 'Lang' },
          { text: 'Question', value: 'Question' },
          { text: 'Answer', value: 'Answer' },
          { text: 'Chatbot Answer', value: 'Chatbot Answer' },
          { text: 'PASSED', value: 'PASSED' },
          { text: 'App ID', value: 'App ID' },
          { text: 'Predicted Intent', value: 'Predicted Intent' },
          { text: 'Score', value: 'Score' },
          { text: 'Entites', value: 'Entites' },
        ]
      }
    },
    mounted() {

    },
    methods: {
      getExcelData(e) {
        let files = e.target.files, f = files[0];
        let reader = new FileReader();
        reader.onload = (e)=> {
          let data = new Uint8Array(e.target.result);
          let workbook = XLSX.read(data, {type: 'array'});
          let sheetName = workbook.SheetNames[0]
          /* DO SOMETHING WITH workbook HERE */
          console.log(workbook);

          let worksheet = workbook.Sheets[sheetName];
          this.sheetData = XLSX.utils.sheet_to_json(worksheet)
          console.log(this.sheetData)
          if (this.sheetData[0].Question && this.sheetData[0].Lang && this.sheetData[0].Answer && this.sheetData[0].Intent) {
            this.setIntentData()
          } else {
            this.$store.dispatch('setSnackbar', {
              text: `Invalid Data`,
              color: 'Error',
              status: true
            })
          }

        };
        reader.readAsArrayBuffer(f);
      },
      async setIntentData() {
        for (let i = 0; i<this.sheetData.length;i++) {
          await this.setSingleIntent(this.sheetData[i], i)
          console.log(this.sheetData[i]['App ID'])
          if (this.sheetData[i]['App ID']) {
            await this.setScore(this.sheetData[i], i)
          }
        }
      },
      async setSingleIntent(intent , i) {
        try {
          const res = await this.$http_gateway.post('test',{
            test_id: i+1,
            bot_id: this.$store.state.bot.botId,
            message:intent.Question
          })

          let botAnswer = res.data.payload.replace(/[*]/g, ' ')
          let answer  = intent.Answer.split('|')
          this.tableData.push({
            index: i+1,
            ...intent,
            ['Chatbot Answer']: botAnswer,
            PASSED: answer.includes(botAnswer) ||
            (this.matchingRegex && new RegExp(this.matchingRegex).test(botAnswer))
                ? 'PASSED' : 'FAILED'
          })
        } catch (e) {
          console.log(e)
          this.tableData.push({
            index: i+1,
            ...intent,
            ['Chatbot Answer']: 'API Error',
            PASSED: 'FAILED'
          })

        } finally {

        }
      },
      async setScore(intent, i){
        try {
          const res = await this.$http_nlp.get(`/apps/${intent['App ID']}/test-prediction`, {
            params: {
              q: intent.Question
            }
          })
          this.tableData[i]['Predicted Intent'] = res.data.intent
          this.tableData[i]['Score'] = res.data.score
          this.tableData[i]['Entites'] = res.data.entities && res.data.entities.length ?
              res.data.entities.map(item=> {return  `${item.entity} : ${item.type}`}).join(',') : 'none'
        }
        catch (e) {
          this.tableData[i]['Predicted Intent'] = 'API Error'
          this.tableData[i]['Score'] = 'API Error'
          this.tableData[i]['Entites'] = 'API Error'
        }
      }
    }
  }
</script>

<style scoped>
.hidden {
  visibility: hidden;
}
</style>
